import axios from "axios";
import { BASE_URL, getGoogleRefreshToken, setGoogleAccessToken } from "./auth";

export async function googleAccessToken() {
  const refreshToken = getGoogleRefreshToken();
  if (!refreshToken) return "";
  const res = await axios.post(
    `${BASE_URL}/auth/token/refresh-token?refresh_token=${refreshToken}`
  );

  if ("access_token" in res.data) {
    setGoogleAccessToken(res.data.access_token);
    return res.data.access_token as string;
  }

  return "";
}
